import { render, staticRenderFns } from "./ErrorSeverity.vue?vue&type=template&id=5342b18e&scoped=true"
import script from "./ErrorSeverity.vue?vue&type=script&lang=js"
export * from "./ErrorSeverity.vue?vue&type=script&lang=js"
import style0 from "./ErrorSeverity.vue?vue&type=style&index=0&id=5342b18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5342b18e",
  null
  
)

export default component.exports